import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "44.654",
  viewBox: "0 0 44.654 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M41.719 23.9L2.725 1.57 0 0v50l2.725-1.572 38.994-21.28 2.935-1.572zM3.249 8.28l11.006 17.19L3.249 41.93zm3.46 34.38L17.19 27.15h17.924zM17.084 23.9L6.498 7.44 35.22 23.9z"
  })]
});